export default "__VITE_ASSET__CpsThJ3H__"